<template>
  <div :class="customClass" v-show="showRsc">
    <div class="widget-title">
      자원 목록 <i class="el-icon-close" @click="onClickRscCloseButton" />
    </div>
    <div class="search-border-none">
      <el-input v-model="searchKeyword" size="small" placeholder="자원 검색" suffix-icon="el-icon-search" @keyup.enter.native="onSearchRscKeyword" />
    </div>
    <el-scrollbar>
      <el-collapse class="menu-wrapper" v-model="activeRsctypes">
        <el-collapse-item v-for="rsctype in rsctypeList" :key="rsctype.rsctypeId" :name="rsctype.rsctypeId">
          <template slot="title">
            <el-tooltip :content="rsctype.rsctypeName" placement="right">
              <span>{{rsctype.rsctypeName}}</span>
            </el-tooltip>
          </template>
          <ul class="list-drag">
            <drag v-for="rsc in getRscList(rsctype.rsctypeId)" :key="`${rsctype.rsctypeId}.${rsc.rscId}`" :transfer-data="rsc" @dragstart="onDragNode" @dragend="onDragEndNode">
              <li @click="onClickRsc(rsc)">{{ rsc.rscName }}</li>
            </drag>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </el-scrollbar>
    <div class="footer" style="padding-bottom: 20px;" v-show="rscKeyList.length > 0">
      <el-scrollbar>
        <ul>
          <drag v-for="rscKey in rscKeyList" :key="`${rscKey.rsctypeId}.${rscKey.rscId}.${rscKey.rscKey}`" :transfer-data="rscKey" @dragstart="onDragNode" @dragend="onDragEndNode">
            <li>{{ rscKey.rscKeyName }}</li>
          </drag>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { isEmpty, clone, filter } from 'lodash';
import ChartAPI from '@/api/chart/chart-analysis';
import { Drag } from 'vue-drag-drop';

export default {
  name: 'WRscTree',
  components: {
    Drag,
  },
  props: {
    /**
     * 자원 트리 css
     */
    customClass: {
      type: String,
      default: 'page-container-left-col has-sub',
    },
    /**
     * 선택한 관리 대상 노드
     */
    selectedTreeNode: {
      type: Object,
    },
  },
  data() {
    return {
      showRsc: false,
      searchKeyword: null,
      selectedRsc: {},
      activeRsctypes: [],
      rsctypeList: [],
      rscKeyList: [],
      dropzoneVisible: false,
    };
  },
  computed: {
    rscParams() {
      let params;
      const obj = this.selectedTreeNode.obj;
      if (!isEmpty(this.selectedTreeNode.rscKey)) {
        params = {
          rscKey: this.selectedTreeNode.rscKey,
          objDefineId: obj.objDefineId,
        };
      } else {
        params = {
          objId: obj.objId,
          managetypeId: obj.objManagetypeId,
          objDefineId: obj.objDefineId,
          objtypeId: obj.objtypeId,
        };
      }

      return params;
    },
  },
  watch: {
    selectedTreeNode() {
      if (!isEmpty(this.selectedTreeNode) && !isEmpty(this.selectedTreeNode.obj)) {
        // 자원 구분키 컴포넌트 hidden
        this.rscKeyList = [];
        // 검색 키워드 리셋
        this.searchKeyword = null;

        this.getChartRscInfo(this.rscParams);
      }
    },
  },
  methods: {
    isEmpty,
    /**
     * 자원 트리를 표현한다.
     *
     * @author gimang
     */
    showTree() {
      this.showRsc = true;
    },
    /**
     * 자원 목록 컴포넌트를 숨김처리한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickRscCloseButton() {
      this.showRsc = false;
      this.$emit('closeTree');
    },
    /**
     * 자원 구분키를 조회한다.
     * @param  {[type]} rsc [description]
     * @return {[type]}     [description]
     * @author jda
     */
    onClickRsc(rsc) {
      const treeNode = this.selectedTreeNode;

      if (isEmpty(treeNode.obj)) {
        return;
      }
      this.selectedRsc = rsc;

      ChartAPI.getObjRscKeys({
        objId: treeNode.obj.objId,
        managetypeId: treeNode.obj.objManagetypeId,
        rsctypeId: rsc.rsctypeId,
        rscId: rsc.rscId,
      }).then((response) => {
        if (response.data.success) {
          this.rscKeyList = response.data.data;
        }
      });
    },
    /**
     * 자원을 검색한다.
     * @return {[type]} [description]
     * @author jda
     */
    onSearchRscKeyword() {
      const searchKeyword = this.searchKeyword;
      const params = clone(this.rscParams);
      Object.assign(params, {
        searchKeyword,
      });

      this.getChartRscInfo(params);
    },
    /**
     * 자원 목록 데이터를 조회한다.
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     * @author jda
     */
    getChartRscInfo(params) {
      ChartAPI.getChartRscInfo(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.rsctypeList = result.rsctypeList;
          this.rscList = result.rscList;
        }
      });
    },
    /**
     * rsctypeId별 rsc정보를 조회한다.
     * @param  {[type]} rsctypeId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getRscList(rsctypeId) {
      const rscList = this.rscList;
      return filter(rscList, {
        rsctypeId,
      });
    },
    /**
     * 트리나 자원 드래그 시 dropzone 생성
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     * @author jda
     */
    onDragNode(node) {
      this.$emit('dragstart', node);
    },
    /**
     * 드래그 노드를 drop했을 경우 dropzone의 스타일을 해제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onDragEndNode() {
      this.$emit('dragend');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/chart/components/tree/RscTree.vue